import { disposeAllManagedLabelsInSubtree } from "./labelUtils";
import { removeIkTargetMarker } from "./ik/ikTargetMarker";
import { removeAllGraspOverlays } from "./grasps/graspVisualizer";

/** CSS2D joint/site constraint labels plus IK/grasp overlays that persist on the scene outside modelGroup. */
export function clearViewportTransientOverlays(scene) {
  if (!scene) return;
  disposeAllManagedLabelsInSubtree(scene);
  removeIkTargetMarker(scene);
  removeAllGraspOverlays(scene);
}
